import React, { useState } from 'react';
import { useUser } from '../contexts/UserContext';
import './AuthModal.css';

const AuthModal = ({ isOpen, onClose, initialMode }) => {
  const { login } = useUser();
  const [isLogin, setIsLogin] = useState(true);
  const [forgotMode, setForgotMode] = useState(false);
  const [resetStep, setResetStep] = useState(1);
  const [resetEmail, setResetEmail] = useState('');
  const [resetCode, setResetCode] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [resetMsg, setResetMsg] = useState('');
  const [resetLoading, setResetLoading] = useState(false);
  React.useEffect(() => { if (isOpen && initialMode === 'register') setIsLogin(false); else if (isOpen && initialMode === 'login') setIsLogin(true); if (isOpen) { setForgotMode(false); setResetStep(1); setResetMsg(''); } }, [isOpen, initialMode]);
  const [formData, setFormData] = useState({
    email: '',
    password: '',
    username: ''
  });
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  if (!isOpen) return null;

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    // Clear specific error when user starts typing
    if (errors[name]) {
      setErrors(prev => ({
        ...prev,
        [name]: ''
      }));
    }
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.email) {
      newErrors.email = 'Email is required';
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = 'Please enter a valid email';
    }

    if (!formData.password) {
      newErrors.password = 'Password is required';
    } else if (formData.password.length < 6) {
      newErrors.password = 'Password must be at least 6 characters';
    }

    if (!isLogin && !formData.username) {
      newErrors.username = 'Username is required';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!validateForm()) {
      return;
    }

    setIsLoading(true);
    setErrors({});

    try {
      const endpoint = isLogin ? '/api/auth/login' : '/api/auth/register';
      const response = await fetch(`${endpoint}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          ...formData,
          referralCode: !isLogin ? (sessionStorage.getItem('referralCode') || null) : undefined
        }),
      });

      const data = await response.json();

      if (response.ok) {
        // Use the login function from UserContext
        login(data.user, data.token);
        
        // Close modal
        onClose();
        
        // Reset form
        setFormData({ email: '', password: '', username: '' });
        
        // Redirect new users to dashboard after registration
        if (!isLogin) {
          window.location.href = '/dashboard';
        }
      } else {
        setErrors({ form: data.error || 'Authentication failed' });
      }
    } catch (error) {
      console.error('Auth error:', error);
      setErrors({ form: 'Network error. Please try again.' });
    } finally {
      setIsLoading(false);
    }
  };


  const handleForgotSubmit = async () => {
    setResetLoading(true); setResetMsg('');
    try {
      if (resetStep === 1) {
        const r = await fetch('/api/auth/forgot-password', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ email: resetEmail }) });
        const d = await r.json();
        if (r.ok) { setResetStep(2); setResetMsg('Check your email for the 6-digit code'); }
        else setResetMsg(d.error || 'Failed');
      } else if (resetStep === 2) {
        const r = await fetch('/api/auth/reset-password', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ email: resetEmail, code: resetCode, newPassword }) });
        const d = await r.json();
        if (r.ok) { setResetStep(3); setResetMsg('Password reset! You can now sign in.'); }
        else setResetMsg(d.error || 'Failed');
      }
    } catch(e) { setResetMsg('Network error'); }
    setResetLoading(false);
  };
  const switchMode = () => {
    setIsLogin(!isLogin);
    setErrors({});
    setFormData({ email: '', password: '', username: '' });
  };

  return (
    <div className="auth-modal-overlay" >
      <div className="auth-modal" onClick={(e) => e.stopPropagation()}>
        <div className="auth-modal-header">
          <h2>{isLogin ? 'Sign In' : 'Create Account'}</h2>
          <button className="auth-modal-close" onClick={onClose}>×</button>
        </div>
        
        {!forgotMode && <>
          {/* Google OAuth Button */}
          <div style={{padding:'0 28px',marginTop:'4px'}}>
            <a
              href="/api/auth/google"
              style={{
                display:'flex',alignItems:'center',justifyContent:'center',gap:'12px',
                width:'100%',padding:'13px 16px',
                background:'#ffffff',
                border:'none',
                borderRadius:'10px',
                color:'#1f1f1f',fontSize:'15px',fontWeight:'600',
                textDecoration:'none',
                cursor:'pointer',transition:'all 0.2s',
                boxSizing:'border-box',
                boxShadow:'0 2px 8px rgba(0,0,0,0.2)'
              }}
              onMouseEnter={(e) => { e.currentTarget.style.boxShadow = '0 4px 16px rgba(0,0,0,0.3)'; e.currentTarget.style.transform = 'translateY(-1px)'; }}
              onMouseLeave={(e) => { e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.2)'; e.currentTarget.style.transform = 'translateY(0)'; }}
            >
              <svg width="20" height="20" viewBox="0 0 24 24" style={{flexShrink:0}}>
                <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 0 1-2.2 3.32v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.1z" fill="#4285F4"/>
                <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/>
                <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05"/>
                <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/>
              </svg>
              Continue with Google
            </a>
          </div>

          <div style={{display:'flex',alignItems:'center',gap:'14px',padding:'16px 28px 8px'}}>
            <div style={{flex:1,height:'1px',background:'rgba(148,163,184,0.15)'}}></div>
            <span style={{color:'#475569',fontSize:'12px',fontWeight:'600',letterSpacing:'0.5px',textTransform:'uppercase'}}>or</span>
            <div style={{flex:1,height:'1px',background:'rgba(148,163,184,0.15)'}}></div>
          </div>

          <form onSubmit={handleSubmit} className="auth-form">
          {!isLogin && (
            <div className="form-group">
              <label htmlFor="username">Username</label>
              <input
                type="text"
                id="username"
                name="username"
                value={formData.username}
                onChange={handleInputChange}
                className={errors.username ? 'error' : ''}
                disabled={isLoading}
              />
              {errors.username && <span className="error-message">{errors.username}</span>}
            </div>
          )}
          
          <div className="form-group">
            <label htmlFor="email">Email</label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleInputChange}
              className={errors.email ? 'error' : ''}
              disabled={isLoading}
            />
            {errors.email && <span className="error-message">{errors.email}</span>}
          </div>
          
          <div className="form-group">
            <label htmlFor="password">Password</label>
            <input
              type="password"
              id="password"
              name="password"
              value={formData.password}
              onChange={handleInputChange}
              className={errors.password ? 'error' : ''}
              disabled={isLoading}
              placeholder="At least 6 characters"
            />
            {errors.password && <span className="error-message">{errors.password}</span>}
          </div>
          
          {errors.form && (
            <div className="form-error">
              {errors.form}
            </div>
          )}
          
          <button 
            type="submit" 
            className="auth-submit-btn"
            disabled={isLoading}
          >
            {isLoading ? 'Please wait...' : (isLogin ? 'Sign In' : 'Create Account')}
          </button>
        </form></>}

        {!forgotMode && (
        <div className="auth-switch">
          <p>
            {isLogin ? "Don't have an account?" : "Already have an account?"}{' '}
            <button type="button" className="auth-switch-btn" onClick={switchMode} disabled={isLoading}>
              {isLogin ? 'Sign up' : 'Sign in'}
            </button>
          </p>
          {isLogin && <p style={{marginTop:'8px'}}><button type="button" className="auth-switch-btn" onClick={()=>{setForgotMode(true);setResetStep(1);setResetMsg('');setResetEmail('');setResetCode('');setNewPassword('');}}>Forgot password?</button></p>}
        </div>
        )}
        
        {forgotMode && (
          <div style={{padding:'20px 28px'}}>
            <div style={{textAlign:'center',marginBottom:'20px'}}>
              <div style={{fontSize:'36px',marginBottom:'8px'}}>{resetStep===3?'🎉':resetStep===2?'🔑':'🔒'}</div>
              <h3 style={{color:'#f1f5f9',margin:'0 0 6px',fontSize:'20px',fontWeight:'800'}}>{resetStep===3?'Password Reset!':resetStep===2?'Enter Reset Code':'Reset Your Password'}</h3>
              <p style={{color:'#94a3b8',fontSize:'13px',margin:0}}>{resetStep===1?'Enter your email and we\'ll send you a 6-digit code':resetStep===2?'Check your email for the 6-digit code':''}</p>
            </div>
            {resetStep===1 && (<>
              <label style={{display:'block',color:'#94a3b8',fontSize:'11px',fontWeight:'600',marginBottom:'5px',textTransform:'uppercase',letterSpacing:'0.5px'}}>Email Address</label>
              <input type="email" value={resetEmail} onChange={e=>setResetEmail(e.target.value)} placeholder="you@example.com" style={{width:'100%',padding:'12px 14px',borderRadius:'10px',border:'1px solid rgba(139,92,246,0.3)',background:'rgba(255,255,255,0.05)',color:'#e2e8f0',fontSize:'14px',marginBottom:'16px',boxSizing:'border-box',outline:'none',transition:'border-color 0.2s'}} onFocus={e=>{e.target.style.borderColor='rgba(139,92,246,0.6)';}} onBlur={e=>{e.target.style.borderColor='rgba(139,92,246,0.3)';}} />
              <button onClick={handleForgotSubmit} disabled={resetLoading||!resetEmail} style={{width:'100%',padding:'14px',borderRadius:'10px',border:'none',background:resetEmail&&!resetLoading?'linear-gradient(135deg,#8b5cf6,#7c3aed)':'rgba(255,255,255,0.06)',color:resetEmail&&!resetLoading?'white':'#475569',fontWeight:'700',cursor:resetEmail&&!resetLoading?'pointer':'default',fontSize:'15px',transition:'all 0.3s',boxShadow:resetEmail&&!resetLoading?'0 4px 15px rgba(139,92,246,0.3)':'none'}}>{resetLoading?'Sending...':'Send Reset Code'}</button>
            </>)}
            {resetStep===2 && (<>
              <label style={{display:'block',color:'#94a3b8',fontSize:'11px',fontWeight:'600',marginBottom:'5px',textTransform:'uppercase',letterSpacing:'0.5px'}}>6-Digit Code</label>
              <input type="text" value={resetCode} onChange={e=>setResetCode(e.target.value)} placeholder="------" maxLength={6} style={{width:'100%',padding:'16px',borderRadius:'10px',border:'2px solid rgba(139,92,246,0.4)',background:'rgba(139,92,246,0.06)',color:'#e2e8f0',fontSize:'24px',marginBottom:'14px',boxSizing:'border-box',textAlign:'center',letterSpacing:'12px',fontWeight:'800',outline:'none'}} onFocus={e=>{e.target.style.borderColor='rgba(139,92,246,0.7)';}} onBlur={e=>{e.target.style.borderColor='rgba(139,92,246,0.4)';}} />
              <label style={{display:'block',color:'#94a3b8',fontSize:'11px',fontWeight:'600',marginBottom:'5px',textTransform:'uppercase',letterSpacing:'0.5px'}}>New Password</label>
              <input type="password" value={newPassword} onChange={e=>setNewPassword(e.target.value)} placeholder="At least 6 characters" style={{width:'100%',padding:'12px 14px',borderRadius:'10px',border:'1px solid rgba(139,92,246,0.3)',background:'rgba(255,255,255,0.05)',color:'#e2e8f0',fontSize:'14px',marginBottom:'16px',boxSizing:'border-box',outline:'none',transition:'border-color 0.2s'}} onFocus={e=>{e.target.style.borderColor='rgba(139,92,246,0.6)';}} onBlur={e=>{e.target.style.borderColor='rgba(139,92,246,0.3)';}} />
              <button onClick={handleForgotSubmit} disabled={resetLoading||!resetCode||newPassword.length<6} style={{width:'100%',padding:'14px',borderRadius:'10px',border:'none',background:resetCode&&newPassword.length>=6&&!resetLoading?'linear-gradient(135deg,#10b981,#059669)':'rgba(255,255,255,0.06)',color:resetCode&&newPassword.length>=6&&!resetLoading?'white':'#475569',fontWeight:'700',cursor:resetCode&&newPassword.length>=6&&!resetLoading?'pointer':'default',fontSize:'15px',transition:'all 0.3s',boxShadow:resetCode&&newPassword.length>=6&&!resetLoading?'0 4px 15px rgba(16,185,129,0.3)':'none'}}>{resetLoading?'Resetting...':'Reset Password'}</button>
            </>)}
            {resetStep===3 && (<>
              <p style={{color:'#10b981',fontSize:'15px',textAlign:'center',margin:'0 0 20px',fontWeight:'600'}}>Your password has been reset successfully!</p>
              <button onClick={()=>{setForgotMode(false);setIsLogin(true);}} style={{width:'100%',padding:'14px',borderRadius:'10px',border:'none',background:'linear-gradient(135deg,#8b5cf6,#7c3aed)',color:'white',fontWeight:'700',cursor:'pointer',fontSize:'15px',boxShadow:'0 4px 15px rgba(139,92,246,0.3)'}}>Sign In Now</button>
            </>)}
            {resetMsg && <p style={{color:resetStep===3?'#10b981':resetMsg.includes('Invalid')||resetMsg.includes('expired')?'#ef4444':'#a78bfa',fontSize:'13px',marginTop:'14px',textAlign:'center',fontWeight:'500'}}>{resetMsg}</p>}
            {resetStep!==3 && <p style={{marginTop:'14px',textAlign:'center'}}><button type="button" className="auth-switch-btn" onClick={()=>setForgotMode(false)} style={{color:'#a78bfa'}}>Back to Sign In</button></p>}
          </div>
        )}
        <div className="auth-info">
          <p>
            {isLogin 
              ? 'Sign in to access your personalized dashboard and plan features.'
              : 'Create an account to track your usage and unlock premium features.'
            }
          </p>
        </div>
      </div>
    </div>
  );
};

export default AuthModal;